import _slicedToArray from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';
function useInfoPopupHandler() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showInfoModal = _useState2[0],
    setShowInfoModal = _useState2[1];
  var toggleInfoModal = function toggleInfoModal() {
    return setShowInfoModal(function (showInfoModal) {
      return !showInfoModal;
    });
  };
  return {
    showInfoModal: showInfoModal,
    toggleInfoModal: toggleInfoModal
  };
}
export default useInfoPopupHandler;